import "./polyfills";
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import SideBar from "./components/SidebarPlugin";
import VueTabs from "vue-nav-tabs";

import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
locale.use(lang);

import "bootstrap/dist/css/bootstrap.css";
import "vue-nav-tabs/themes/vue-tabs.scss";
import "./assets/sass/light-bootstrap-dashboard.scss";
import "./assets/styles/dark-theme-override.css";

export default {
  async install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(SideBar);
    Vue.use(VueTabs);
  },
};
